import React from 'react';

import './text_input.css';

export interface InputProps {
    type?: 'text' | 'password';
    defaultValue?: string;
    value?: string;
    className?: string;
    onClick?: () => void;
    onChange?: (value: string) => void;
    readOnly?: boolean;
    placeHolder?: string;
}

const TextInput = ({
    type = 'text',
    defaultValue = undefined,
    value = undefined,
    className = '',
    onClick = undefined,
    onChange = undefined,
    readOnly = undefined,
    placeHolder = '',
}: InputProps) => {
    let onChangeInternal = undefined;
    if (onChange) {
        onChangeInternal = (event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value);
        };
    }

    return (
        <input
            type={type}
            defaultValue={defaultValue}
            value={value}
            className={'text_field_input ' + className}
            onClick={onClick}
            onChange={onChangeInternal}
            readOnly={readOnly}
            placeholder={placeHolder}
        ></input>
    );
};

export default TextInput;
